<template>
  <base-ifp-filter
    :emphasize="hasInternalSearchTerm"
    disable-value-display-emphasis
    class="ifp-filter-title-ref-search"
    label-icon="search"
    optionless
  >
    <template #value-display>
      <input
        ref="inputRef"
        :value="internalSearchTerm"
        class="ifp-filter-title-ref-search__input"
        placeholder="Filter by title or #123…"
        @input="(val: Event) => handleInput((val.target as HTMLInputElement).value)"
      >
    </template>
  </base-ifp-filter>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import { debounce } from 'lodash-es'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */

export default defineComponent({
  name: 'IfpFilterTitleRefSearch',

  props: {
    searchTerm: {
      type: String,
      required: true,
    },
  },

  emits: ['search-term-updated'],

  data() {
    return {
      internalSearchTerm: '',
      emphasizeFilter: false,
      debounceUpdateSearchTerm: null as any,
    }
  },

  computed: {
    hasInternalSearchTerm(): boolean {
      return (
        this.internalSearchTerm !== null &&
        this.internalSearchTerm.trim().length > 0
      )
    },
  },

  watch: {
    searchTerm: {
      immediate: true,
      handler(val) {
        this.internalSearchTerm = val
      },
    },
  },
  created() {
    this.debounceUpdateSearchTerm = debounce(this.updateSearchTerm, 500)
  },
  mounted() {
    if (this.hasInternalSearchTerm) {
      // @ts-ignore
      this.$refs.inputRef.focus()
    }
  },
  methods: {
    updateSearchTerm(val: string) {
      this.$emit('search-term-updated', val)
    },
    handleInput(val: string) {
      this.internalSearchTerm = val
      this.debounceUpdateSearchTerm(val)
    },
  },
})
</script>

<style lang="scss">
.ifp-filter-title-ref-search {
  &__input {
    width: 136px;
    background: transparent;
    border: transparent;
    outline: none;
    @include lettering--p-sm;
  }
}
</style>
